import request from '@/utils/request';
import { emallApi } from '@/utils/util';

// 代付-获取主订单信息
export function getMainOrderByParentId(params) {
  return request({
    url: `${emallApi}/order/getMainOrderByParentId`,
    method: 'get',
    params,
  });
}
// 代付-支付状态check true:链接失效 ; false:可以支付
export function checkPayStatus(params) {
  return request({
    url: `${emallApi}/order/checkPayStatus`,
    method: 'get',
    params,
  });
}
